import styleConfig from '../../muiTheme';

const styles = {
  drawerHeadWrapper: {
    height: '180px',
    backgroundColor: styleConfig.palette.primary.primaryDark1,
    padding: '10px 10px 10px 15px',
    boxShadow: '0px 1px 5px 0px rgba(100, 100, 100, 0.75)',
    display: 'flex',
    justifyContent: 'center',
    flexDirection: 'column',
  },
  drawerHeader: {
    padding: '5px 0 10px 0',
    borderBottom: `1px dashed ${styleConfig.palette.white}`,
    margin: '0 0 15px 0',
    font: 'bold 22px "arial"',
    color: styleConfig.palette.white,
  },
  greet: {
    font: 'normal 13px Arial',
    color: styleConfig.palette.whiteOpacity8,
    padding: '0 0 5px 0',
    margin: '0',
  },
  drawerUserName: {
    margin: '0',
    font: 'bold 16px Arial',
    color: styleConfig.palette.white,
    padding: '0 0 10px 0',
  },
};

export default styles;
